import React, { useState, useEffect } from "react";
import axiosInstance from "../../config/axios";
import {
  formatCurrency,
  formatDate,
  getEFTTypeDisplayName,
  filterCommissionTrustActivityEFTs,
} from "../../utils/eftUtils";

const EFTPaymentTables = ({ trade }) => {
  const [realEstateTrustEFTs, setRealEstateTrustEFTs] = useState([]);
  const [commissionTrustEFTs, setCommissionTrustEFTs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!trade?._id) {
      setLoading(false);
      return;
    }
    let cancelled = false;
    const fetchEFTs = async () => {
      setLoading(true);
      try {
        const [retRes, ctRes] = await Promise.all([
          axiosInstance.get(`/real-estate-trust-eft/trade/${trade._id}`),
          axiosInstance.get(`/commission-trust-eft/trade/${trade._id}`),
        ]);
        if (!cancelled) {
          setRealEstateTrustEFTs(retRes.data || []);
          setCommissionTrustEFTs(ctRes.data || []);
        }
      } catch (err) {
        if (!cancelled) {
          console.error("Error fetching EFTs:", err);
          setRealEstateTrustEFTs([]);
          setCommissionTrustEFTs([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    fetchEFTs();
    return () => { cancelled = true; };
  }, [trade?._id]);

  const renderTable = (title, efts) => (
    <div className="mb-6">
      <h3 className="font-semibold text-lg mb-2">{title}</h3>
      {efts.length === 0 ? (
        <p className="text-gray-500 text-sm">No records found.</p>
      ) : (
        <table className="min-w-full border border-gray-300 text-sm">
          <thead>
            <tr className="bg-gray-100">
              <th className="border px-2 py-1 text-left">EFT #</th>
              <th className="border px-2 py-1 text-left">Date</th>
              <th className="border px-2 py-1 text-right">Amount</th>
              <th className="border px-2 py-1 text-left">Recipient</th>
              <th className="border px-2 py-1 text-left">Type</th>
              <th className="border px-2 py-1 text-left">Description</th>
            </tr>
          </thead>
          <tbody>
            {efts.map((eft) => (
              <tr key={eft._id}>
                <td className="border px-2 py-1">{eft.eftNumber || "-"}</td>
                <td className="border px-2 py-1">
                  {formatDate(eft.chequeDate || eft.date)}
                </td>
                <td className="border px-2 py-1 text-right">
                  {formatCurrency(eft.amount)}
                </td>
                <td className="border px-2 py-1">{eft.recipient || "-"}</td>
                <td className="border px-2 py-1">
                  {getEFTTypeDisplayName(eft.type) || "-"}
                </td>
                <td className="border px-2 py-1">{eft.description || "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );

  if (loading) {
    return (
      <div className="mb-6">
        <p className="text-gray-500">Loading EFT payment data...</p>
      </div>
    );
  }

  return (
    <>
      {renderTable("Real Estate Trust Payments", realEstateTrustEFTs)}
      {renderTable(
        "Commission Trust Payments",
        filterCommissionTrustActivityEFTs(commissionTrustEFTs),
      )}
    </>
  );
};

export default EFTPaymentTables;
